import React from 'react';
import {Search} from "../../components/search/Search";
import {useDocumentTitle} from "../../hooks/useDocumentTitle";

export const SearchPage: React.FC = () => {
    useDocumentTitle('Search');
    return (
            <Search />
    );
};
